/* eslint-disable */
/* tslint:disable */
export interface AbsenceRequest {
	/** @format uuid */
	userId?: string;
	/** @format date-time */
	from?: string;
	/** @format date-time */
	to?: string;
}

export interface AccessTokenResponse {
	tokenType?: string | null;
	accessToken: string | null;
	/** @format int64 */
	expiresIn: number;
	refreshToken: string | null;
}

export interface AssignCaseToComplaintRequest {
	complaintId: string | null;
	caseId: string | null;
}

export interface AssignCaseToComplaintResponse {
	/** @format uuid */
	id?: string;
	hid: string | null;
	title: string | null;
	/** @format uuid */
	categoryId?: string;
	medium?: string | null;
	externalNote?: string | null;
}

export interface CreateComplaintResponse {
	id: string;
	hid: string;
}

export interface Callback {
	/** @format uuid */
	id?: string;
	/** @format date-time */
	createdDate?: string;
	/** @format date-time */
	updatedDate?: string;
	/** @format date-time */
	validToDate?: string;
	emailToken: string | null;
	complaint: Complaint;
	text: string | null;
	answer?: string | null;
	files?: File[] | null;
	links?: Link[] | null;
	createdUser?: User;
	updatedUser?: User;
	/** @format uuid */
	createdUserId?: string | null;
	/** @format uuid */
	updatedUserId?: string | null;
}

export interface CallbackRequest {
	/** @format uuid */
	complaintId: string;
	text: string;
	validToDate: string;
}

export interface CallbackResponse {
	/** @format uuid */
	id: string;
	text: string;
	answer: string;
	files: FileResponse[];
	links: LinkResponse[];
	complaint: ComplaintResponse;
	/** @format date-time */
	createdDate: string;
	/** @format date-time */
	validToDate: string;
	/** @format date-time */
	answeredDate?: string | null;
}

export interface Case {
	/** @format uuid */
	id?: string;
	hid: string | null;
	/** @format date-time */
	createdDate?: string;
	/** @format date-time */
	updatedDate?: string;
	title: string | null;
	complaints?: Complaint[] | null;
	state?: CaseState;
	/** @format date-time */
	publishedDate?: string | null;
	/** @format date-time */
	decidedDate?: string | null;
	category: Category;
	mediums?: Medium[] | null;
	reaches?: Reach[] | null;
	sectors?: Sector[] | null;
	statements?: Statement[] | null;
	decisions?: Decision[] | null;
	openAiResults?: OpenAiResult[] | null;
	preVoteRole?: Role;
	/** @format date-time */
	preVoteStartDate?: string | null;
	/** @format date-time */
	preVoteEndDate?: string | null;
	voteRoles?: Role[] | null;
	/** @format date-time */
	voteStartDate?: string | null;
	/** @format date-time */
	voteEndDate?: string | null;
	files?: File[] | null;
	links?: Link[] | null;
	externalNote?: string | null;
	internalNote?: string | null;
	createdUser?: User;
	updatedUser?: User;
	/** @format uuid */
	createdUserId?: string | null;
	/** @format uuid */
	updatedUserId?: string | null;
}

export interface CaseRequestStatementRequest {
	caseId: string | null;
	userId: string | null;
	/** @format date-time */
	firstValidDate?: string;
	question: string | null;
}

export interface CasesResponse {
	items: CaseResponse[];
	counts: SearchResponseCount[];
	totalCount: number;
	page: number;
	pageSize: number;
}

export interface CasePublicResponse {
	id: string;
	publishedDate: string;
	title: string;
	reasonText: string;
	state: CaseState;
	category: CategoryResponse;
	mediums?: MediumResponse[];
	complaints?: ComplaintPublicResponse[];
}

export interface CaseAndComplaintPublicResponse {
	id: string;
	publishedDate: string;
	title: string;
	category: CategoryResponse;
	mediums: MediumResponse[];
	sectors: SectorResponse[];
	isCase: boolean;
	caseState?: CaseState | null;
	state?: CaseState | null;
	decidedDate?: string | null;
}

export interface CasesAndComplaintsPublicResponse {
	items: CaseAndComplaintPublicResponse[];
	counts: SearchResponseCount[];
	totalCount: number;
	page: number;
	pageSize: number;
}
export interface CasesPublicResponse {
	items: CasePublicResponse[];
	counts: SearchResponseCount[];
	totalCount: number;
	page: number;
	pageSize: number;
}

export interface ComplaintPublicResponse {
	id: string;
	publishedDate: string;
	title: string;
	text: string;
	caseState: CaseState | null;
	category: CategoryResponse;
	medium: MediumResponse;
	reasonText?: string;
	notResponsibleReason?: string | null;
	notResponsibleRelevantAuthority?: string | null;
	decidedDate?: string | null;
}

export interface ComplaintsPublicResponse {
	items: ComplaintPublicResponse[];
	counts: SearchResponseCount[];
	totalCount: number;
	page: number;
	pageSize: number;
}

export interface SectorResponse {
	/** @format uuid */
	id: string;
	name: string;
}

export interface CaseResponse {
	/** @format uuid */
	id: string;
	hid: string;
	/** @format date-time */
	createdDate: string;
	/** @format date-time */
	updatedDate: string;
	title: string;
	complaints: ComplaintResponse[];
	state: CaseState;
	sectors: SectorResponse[];
	/** @format date-time */
	publishedDate: string | null;
	/** @format date-time */
	decidedDate: string | null;
	statementsDate: string | null;
	category: CategoryResponse;
	mediums: MediumResponse[];
	reaches: ReachResponse[];
	decisions: DecisionResponse[];
	statements: StatementResponse[];
	preVoteRole?: RoleResponse | null;
	/** @format date-time */
	preVoteStartDate?: string | null;
	/** @format date-time */
	preVoteEndDate?: string | null;
	voteRoles?: RoleResponse[];
	statementRoles?: RoleResponse[];
	/** @format date-time */
	voteStartDate?: string | null;
	/** @format date-time */
	voteEndDate?: string | null;
	files?: FileResponse[];
	links?: LinkResponse[];
	internalNote?: string;
	externalNote?: string;
	reasonText?: string;
}

/** @format int32 */
export enum CaseState {
	NoStatus = 'NoStatus',
	ExaminationSmallSenate = 'ExaminationSmallSenate',
	ExaminationSmallSenateRunning = 'ExaminationSmallSenateRunning',
	Statements = 'Statements',
	ExaminationWerberat = 'ExaminationWerberat',
	ExaminationWerberatRunning = 'ExaminationWerberatRunning',
	DecisionSensitization = 'DecisionSensitization',
	DecisionNoReason = 'DecisionNoReason',
	DecisionStop = 'DecisionStop',
	ImmediateSubjectWithdrawal = 'ImmediateSubjectWithdrawal',
	NotResponsible = 'NotResponsible',
	ProcedureNotPossible = 'ProcedureNotPossible',
	Unfounded = 'Unfounded',
}

export interface StatisticDecisionResponseItem {
	decisionState: DecisionState;
	decisionType: DecisionType;
	count: number;
}

export interface StatisticCategoryResponseItem {
	category: CategoryResponse;
	decisionType: DecisionType;
	count: number;
}

export interface StatisticResponse {
	categories: StatisticCategoryResponseItem[];
	decisions: StatisticDecisionResponseItem[];
}

export interface StatisticResponseWithCaseId {
	categories: StatisticCategoryResponseItem[];
	decisions: StatisticDecisionResponseItem[];
	caseId: string;
}

export interface Category {
	/** @format uuid */
	id: string;
	number: string;
	/** @format uuid */
	parentId?: string | null;
	parent?: Category;
	children?: Category[] | null;
	name: string | null;
	isFromCodeOfEthics: boolean;
	decisions?: Decision[] | null;
}

export interface CategoryDto {
	number: string;
}

export interface CategoryResponse {
	/** @format uuid */
	id: string;
	name: string;
	number: string;
}

export interface Complaint {
	/** @format uuid */
	id?: string;
	hid: string | null;
	/** @format date-time */
	createdDate?: string;
	/** @format date-time */
	updatedDate?: string;
	category: Category;
	case?: Case;
	state: ComplaintState;
	/** @format date-time */
	publishedDate?: string | null;
	/** @format date-time */
	confirmedDate?: string | null;
	title: string | null;
	emailToken: string | null;
	medium: Medium;
	gender?: Gender;
	firstName: string | null;
	lastName: string | null;
	company?: string | null;
	email: string | null;
	phone: string | null;
	text: string | null;
	files?: File[] | null;
	links?: Link[] | null;
	internalNote?: string | null;
	callbacks?: Callback[] | null;
	createdUser?: User;
	updatedUser?: User;
	/** @format uuid */
	createdUserId?: string | null;
	/** @format uuid */
	updatedUserId?: string | null;
	decidedDate?: string | null;
}

export interface ComplaintNotResponsibleRequest {
	complaintId: string | null;
	notResponsibleReason: string | null;
	notResponsibleRelevantAuthority: string | null;
}

export interface ComplaintsResponse {
	items: ComplaintResponse[];
	counts: SearchResponseCount[];
	totalCount: number;
	page: number;
	pageSize: number;
}

export interface ComplaintResponse {
	/** @format uuid */
	id: string;
	hid: string;
	title: string;
	case?: CaseResponse;
	category: CategoryResponse;
	/** @format date-time */
	createdDate?: string | null;
	/** @format date-time */
	updatedDate?: string | null;
	text: string;
	medium: MediumResponse;
	callbacks: CallbackResponse[];
	links: LinkResponse[];
	files: FileResponse[];
	state: ComplaintState;
	isCasePublished?: boolean;
	publishedDate: string | null;
	confirmedDate: string | null;
	notResponsibleReason?: string | null;
	notResponsibleRelevantAuthority?: string | null;
	firstName: string;
	lastName: string;
	gender: Gender;
	email: string;
	phone: string;
	company: string | null;
	decidedDate: string | null;
	internalNote: string | null;
}

export enum ComplaintState {
	NotAssigned = 'NotAssigned',
	Assigned = 'Assigned',
	NotResponsible = 'NotResponsible',
	UnansweredCallbacks = 'HasOpenCallbacks',
}

/** @format int32 */
export enum DecisionState {
	Null = 'Null',
	NoReason = 'NoReason',
	Awareness = 'Awareness',
	Stop = 'Stop',
	Biased = 'Biased',
	StopSmallSenate = 'StopSmallSenate',
	GoSmallSenate = 'GoSmallSenate',
	UserAbsent = 'UserAbsent',
}

export enum ComplaintFilters {
	NotAssigned = ComplaintState.NotAssigned,
	Assigned = ComplaintState.Assigned,
	UnansweredCallbacks = 'HasOpenCallbacks',
}

export enum CaseFilters {
	Statements = CaseState.Statements,
	ExaminationSmallSenate = CaseState.ExaminationSmallSenate,
	ExaminationWerberat = CaseState.ExaminationWerberat,
	DecisionNoReason = CaseState.DecisionNoReason,
}

export interface ConfirmComplaintRequest {
	/** @format uuid */
	complaintId: string;
	token: string | null;
}

export interface ConfirmRequest {
	/** @format uuid */
	userId: string;
	password: string | null;
	code: string | null;
	changedEmail?: string | null;
}

export interface CreateAiSuggestionRequest {
	/** @format uuid */
	caseId?: string;
	/** @format float */
	temperature?: number;
}

export interface CreateCaseFromComplaintRequest {
	/** @format uuid */
	complaintId: string;
	title: string | null;
}

export interface CreateCaseFromComplaintResponse {
	/** @format uuid */
	id?: string;
	hid: string | null;
	title: string | null;
	/** @format uuid */
	categoryId?: string;
	medium?: string | null;
	externalNote?: string | null;
}

export interface Decision {
	/** @format uuid */
	id?: string;
	hid: string | null;
	user: User;
	role: Role;
	/** @format date-time */
	createdDate?: string;
	/** @format date-time */
	updatedDate?: string;
	case: Case;
	/** @format uuid */
	caseId: string;
	shared?: boolean;
	categories?: Category[] | null;
	decisionState: DecisionState;
	reasonText?: string | null;
	createdUser?: User;
	updatedUser?: User;
	/** @format uuid */
	createdUserId?: string | null;
	/** @format uuid */
	updatedUserId?: string | null;
}

export interface DecisionsResponse {
	items: DecisionResponse[];
	counts: SearchResponseCount[];
	totalCount: number;
	page: number;
	pageSize: number;
}

export enum DecisionType {
	SmallSenate = 'SmallSenate',
	Werberat = 'Werberat',
	JungerWerberat = 'JungerWerberat',
}

export interface DecisionResponse {
	/** @format uuid */
	id: string;
	hid: string;
	user: UserResponse;
	role: Role;
	decidedDate: string | null;
	decisionType: DecisionType;
	case: CaseResponse;
	shared: boolean;
	categories: CategoryResponse[];
	decisionState: DecisionState;
	reasonText: string;
}

export interface AuditResponse {
	type: AuditType;
	tableName: string;
	userId?: string;
	firstName: string;
	lastName: string;
	roles: string[];
	dateTime: string;
	affectedColumns: string;
	changes: string;
}

export enum AuditType {
	Create = 'Create',
	Update = 'Update',
	Delete = 'Delete',
}

export enum ActivityKey {
	ComplaintWithoutCase = 'ComplaintWithoutCase',
	CallbackWithAnswer = 'CallbackWithAnswer',
	StatementWithAnswer = 'StatementWithAnswer',
	DecisionWithReason = 'DecisionWithReason',
	StatementExpiredFirstValid = 'StatementExpiredFirstValid',
	StatementExpiredLastValid = 'StatementExpiredLastValid',
	CaseDecided = 'CaseDecided',
	ComplaintDecided = 'ComplaintDecided',
	CasePublished = 'CasePublished',
	ComplaintPublished = 'ComplaintPublished',
}

export enum ActivityType {
	Complaint = 'Complaint',
	Case = 'Case',
	Statement = 'Statement',
	Callback = 'Callback',
	Decision = 'Decision',
}

export interface ActivityResponse {
	id: string;
	complaintId: string | null;
	hid: string | null;
	timestamp: string | null;
	title: string | null;
	key: ActivityKey;
	type: ActivityType;
}

export interface TodoResponse {
	id: string;
	title: string;
	createdDate: string;
	isDone?: boolean;
}

export interface TodoItem extends TodoResponse {
	isEditing?: boolean;
}

export interface DownloadCaseMediaResponse {
	/** @format byte */
	fileContent: string | null;
	fileName: string | null;
	contentType: string | null;
}

export interface File {
	/** @format uuid */
	id?: string;
	/** @format date-time */
	createdDate?: string;
	/** @format date-time */
	updatedDate?: string;
	fileName: string | null;
	contentType: string | null;
	/** @format byte */
	bytes: string | null;
	createdUser?: User;
	updatedUser?: User;
	/** @format uuid */
	createdUserId?: string | null;
	/** @format uuid */
	updatedUserId?: string | null;
}

export interface FileDto {
	fileName: string;
	contentType: string;
	/** @format byte */
	bytes: Blob;
}

export interface FileResponse {
	/** @format uuid */
	id: string;
	fileName: string;
	fileSize: number;
	contentType: string;
	url: string;
}

interface FileResponseWithBytes extends FileResponse {
	bytes: any;
}

export interface DetailFile {
	file: FileResponseWithBytes;
	isNew: boolean;
}

export interface DetailLink {
	link: LinkResponse;
	isNew: boolean;
}

export interface PutDecisionRequest {
	id: string | null;
	reasonText: string;
	decisionState: DecisionState;
	categories: CategoryDto[];
	shared: boolean;
}

export enum SendCaseType {
	SmallSenate = 'SmallSenate',
	Werberat = 'Werberat',
}

export interface SendCaseRequest {
	caseId: string | null;
	sendCaseType: SendCaseType;
	roles: RoleDto[];
	fromDate: string;
	toDate: string;
}

export interface FinalDecisionRequest {
	/** @format uuid */
	caseId: string;
	state?: CaseState;
	text: string;
}

export interface ForgotPasswordRequest {
	email: string;
}

/** @format int32 */
export enum Gender {
	Male = 'Male',
	Female = 'Female',
	Diverse = 'Diverse',
}

export interface HttpValidationProblemDetails {
	type?: string | null;
	title?: string | null;
	/** @format int32 */
	status?: number | null;
	detail?: string | null;
	instance?: string | null;
	errors?: Record<string, string[]>;
	[key: string]: any;
}

export interface InfoRequest {
	newEmail?: string | null;
	newPassword?: string | null;
	oldPassword?: string | null;
}

export interface InfoResponse {
	email: string | null;
	isEmailConfirmed: boolean;
}

export interface Link {
	/** @format uuid */
	id?: string;
	/** @format date-time */
	createdDate?: string;
	/** @format date-time */
	updatedDate?: string;
	name: string | null;
	type: LinkType;
	url: string | null;
	createdUser?: User;
	updatedUser?: User;
	/** @format uuid */
	createdUserId?: string | null;
	/** @format uuid */
	updatedUserId?: string | null;
}

export interface LinkDto {
	url: string;
	name: string;
	type: LinkType;
}

export interface LinkResponse {
	/** @format uuid */
	id: string;
	name: string;
	type: LinkType;
	url: string;
	createdDate: string;
}

/** @format int32 */
export enum LinkType {
	Youtube = 'Youtube',
	Facebook = 'Facebook',
	Twitter = 'Twitter',
	Instagram = 'Instagram',
	LinkedIn = 'LinkedIn',
	Other = 'Other',
}

export interface LoginRequest {
	email: string;
	password: string;
	twoFactorCode?: string | null;
	twoFactorRecoveryCode?: string | null;
}

export interface Medium {
	/** @format uuid */
	id?: string;
	name: string;
	cases?: Case[];
}

export interface MediumDto {
	name: string;
}

export interface MediumResponse {
	/** @format uuid */
	id: string;
	name: string;
}

export interface OpenAiResult {
	/** @format uuid */
	id?: string;
	request: string | null;
	response: string | null;
	caseState: CaseState;
	case?: Case;
	/** @format date-time */
	createdDate?: string;
	/** @format date-time */
	updatedDate?: string;
}

export interface OpenAiResultReponse {
	/** @format date-time */
	createdDate: string;
	response: string;
	caseState: CaseState;
}

export interface PreliminaryDecisionRequest {
	/** @format uuid */
	caseId: string;
	state?: CaseState;
	fromSmallSenate?: boolean;
	text: string | null;
}

export interface PutStatementDeadlineRequest {
	/** @format uuid */
	statementId: string;
	/** @format date-time */
	lastValidDate: string;
}

export interface PutStatementStateRequest {
	/** @format uuid */
	statementId: string;
	state: StatementState;
}

export interface Reach {
	/** @format uuid */
	id?: string;
	name: string | null;
	cases?: Case[] | null;
}

export interface ReachDto {
	name: string;
}

export interface ReachResponse {
	/** @format uuid */
	id: string;
	name: string;
}

export interface RefreshRequest {
	refreshToken: string | null;
}

export interface RegisterRequest {
	userName: string;
	email: string;
	firstName: string;
	lastName: string;
	initials?: string;
	seal: boolean;
	phoneNumber?: string;
	company?: string | null;
	street?: string | null;
	postalCode?: string | null;
	city?: string | null;
	roles: RoleDto[];
	gender: Gender | null;
	titleBefore?: string | null;
	titleAfter?: string | null;
	internalNote?: string | null;
}

export interface StatementEmailReminderRequest {
	/** @format uuid */
	statementId: string;
}

export interface ResendConfirmationEmailRequest {
	email: string;
}

export interface ResetPasswordRequest {
	email: string | null;
	resetCode: string | null;
	newPassword: string | null;
}

export interface Role {
	/** @format uuid */
	id?: string;
	name: string;
	normalizedName?: string | null;
	concurrencyStamp?: string | null;
	isUserRole?: boolean;
	cases?: Case[] | null;
}

export interface RoleDto {
	name: string;
}

export type RoleResponse = {
	/** @format uuid */
	id: string;
	name: string;
	normalizedName: string;
};

export interface SearchCaseRequest {
	searchTerm?: string | null;
	category?: CategoryDto | null;
	medium?: MediumDto | null;
	sector?: SectorDto | null;
	reach?: ReachDto | null;
	states?: CaseState[] | null;
	isPublished?: boolean | null;
	/** @format date-time */
	fromDate?: string | null;
	/** @format date-time */
	toDate?: string | null;
	shouldSetDecision?: boolean;
	isInSmallSenate?: boolean;
	isDecisionOpen?: boolean;
	isDecisionDoneButRunning?: boolean;
	isDecisionDone?: boolean;
	iWasBiased?: boolean;
}

export interface ChangeCaseStateRequest {
	caseId: string;
	state: CaseState;
}

export interface SearchComplaintRequest {
	searchTerm?: string | null;
	category?: CategoryDto | null;
	medium?: MediumDto | null;
	hasAttachments?: boolean | null;
	states?: ComplaintState[] | null;
	isPublished?: boolean | null;
	hasOpenCallbacks?: boolean | null;
	/** @format date-time */
	fromDate?: string | null;
	/** @format date-time */
	toDate?: string | null;
}

export interface SearchContactRequest {
	searchTerm?: string | null;
	role?: RoleDto | null;
	/** @format date-time */
	fromDate?: string | null;
	/** @format date-time */
	toDate?: string | null;
	withUsers?: boolean | null;
}

export interface SearchDecisionRequest {
	searchTerm?: string | null;
	hasReason?: boolean | null;
	isShared?: boolean | null;
	role?: RoleDto | null;
	state?: DecisionState | null;
	/** @format date-time */
	fromDate?: string | null;
	/** @format date-time */
	toDate?: string | null;
}

export interface SearchUserRequest {
	searchTerm?: string | null;
	role?: RoleDto | null;
	/** @format date-time */
	fromDate?: string | null;
	/** @format date-time */
	toDate?: string | null;
	lessThanTwentyFivePercentDecisions?: boolean | null;
	hasSeal?: boolean | null;
	status?: UserStatus | null;
}

export interface Sector {
	/** @format uuid */
	id?: string;
	name: string | null;
	cases?: Case[] | null;
}

export interface SectorDto {
	name: string;
}

export interface Statement {
	/** @format uuid */
	id?: string;
	hid: string | null;
	/** @format date-time */
	createdDate?: string;
	/** @format date-time */
	updatedDate?: string;
	emailToken: string | null;
	/** @format date-time */
	firstValidDate?: string;
	/** @format date-time */
	lastValidDate?: string | null;
	/** @format date-time */
	answeredDate?: string | null;
	contact: User;
	title: string | null;
	question?: string | null;
	answer?: string | null;
	state?: StatementState;
	files?: File[] | null;
	links?: Link[] | null;
	internalNote?: string | null;
	createdUser?: User;
	updatedUser?: User;
	/** @format uuid */
	createdUserId?: string | null;
	/** @format uuid */
	updatedUserId?: string | null;
}

export interface StatementResponse {
	/** @format uuid */
	id: string;
	hid: string;
	title: string;
	question?: string;
	createdDate: string;
	answer: string | null;
	answeredDate: string | null;
	files: FileResponse[];
	links: LinkResponse[];
	internalNote: string | null;
	state: StatementState;
	contact: UserResponse;
	firstValidDate: string;
	lastValidDate: string | null;
	case: CaseResponse;
}

/** @format int32 */
export enum StatementState {
	NotReceived = 'NotReceived',
	Received = 'Received',
	DeadlineExtended = 'DeadlineExtended',
	DeadlineExpired = 'DeadlineExpired',
	StatementRejected = 'StatementRejected',
}

export interface TwoFactorRequest {
	enable?: boolean | null;
	twoFactorCode?: string | null;
	resetSharedKey?: boolean;
	resetRecoveryCodes?: boolean;
	forgetMachine?: boolean;
}

export interface TwoFactorResponse {
	sharedKey: string | null;
	/** @format int32 */
	recoveryCodesLeft: number;
	recoveryCodes?: string[] | null;
	isTwoFactorEnabled: boolean;
	isMachineRemembered: boolean;
}

export interface User {
	/** @format uuid */
	id: string;
	userName?: string | null;
	normalizedUserName?: string | null;
	email?: string | null;
	normalizedEmail?: string | null;
	emailConfirmed?: boolean;
	passwordHash?: string | null;
	securityStamp?: string | null;
	concurrencyStamp?: string | null;
	phoneNumber?: string | null;
	phoneNumberConfirmed?: boolean;
	twoFactorEnabled?: boolean;
	/** @format date-time */
	lockoutEnd?: string | null;
	lockoutEnabled?: boolean;
	/** @format int32 */
	accessFailedCount?: number;
	/** @format date-time */
	lastLogin?: string | null;
	/** @format date-time */
	deactivatedDate?: string | null;
	hid?: string | null;
	gender?: Gender | null;
	titleBefore?: string | null;
	titleAfter?: string | null;
	firstName?: string | null;
	lastName?: string | null;
	initials?: string | null;
	seal?: boolean;
	company?: string | null;
	street?: string | null;
	postalCode?: string | null;
	city?: string | null;
	isContact?: boolean;
	status?: UserStatus;
	roles: Role[];
	/** @format date-time */
	createdDate?: string;
	createdUser?: User;
	/** @format uuid */
	createdUserId?: string | null;
	/** @format date-time */
	updatedDate?: string;
	updatedUser?: User;
	/** @format uuid */
	updatedUserId?: string | null;
	userAbsences?: UserAbsence[] | null;
	internalNote?: string | null;
}

export interface UserAbsence {
	/** @format uuid */
	id?: string;
	user?: User;
	/** @format uuid */
	userId: string;
	/** @format date-time */
	createdDate?: string;
	/** @format date-time */
	updatedDate?: string;
	/** @format date-time */
	from: string;
	/** @format date-time */
	to: string;
	createdUser?: User;
	updatedUser?: User;
	/** @format uuid */
	createdUserId?: string | null;
	/** @format uuid */
	updatedUserId?: string | null;
}

export interface UserAbsenceResponse {
	id: string;
	from: string;
	to: string;
	createdDate: string;
}

export interface SearchResponseCount {
	item1: string | null;
	item2: number;
}

export interface UsersResponse {
	items: UserResponse[];
	counts: SearchResponseCount[];
	totalCount: number;
	page: number;
	pageSize: number;
}

export interface UserResponse {
	/** @format uuid */
	id: string;
	hid: string;
	gender: Gender | null;
	email: string;
	titleBefore: string | null;
	titleAfter: string | null;
	userName: string;
	firstName: string;
	lastName: string;
	initials: string | null;
	lastLogin: string | null;
	createdDate: string;
	phoneNumber?: string | null;
	seal: boolean;
	company: string | null;
	street: string;
	postalCode: string;
	city: string | null;
	roles: RoleResponse[];
	lastUserAbsence: UserAbsenceResponse | null;
	userAbsences: UserAbsenceResponse[];
	status: UserStatus;
	isContact: boolean;
	internalNote: string | null;
}

export interface SaveUserRequest {
	/** @format uuid */
	userId: string;
	gender: Gender;
	email: string;
	titleBefore?: string | null;
	titleAfter?: string | null;
	firstName: string;
	lastName: string;
	initials?: string | null;
	phoneNumber?: string | null;
	seal?: boolean;
	company?: string | null;
	street: string;
	postalCode: string;
	city?: string | null;
	internalNote?: string | null;
}

/** @format int32 */
export enum UserStatus {
	Pending = 'Pending',
	Active = 'Active',
	Deactivated = 'Deactivated',
	Absent = 'Absent',
}

export interface TableSort {
	prop: string;
	order: 'ascending' | 'descending';
}
